import type { TDeepthLevelStack } from '@/components/organisms/Form/Validator';
import { useMemo } from 'react';

import type { TRule } from '@ballerine/common';

import { replaceTagsWithIndexesInRule } from './helpers';

export const useRules = (rules?: TRule[], stack?: TDeepthLevelStack) => {
  const rulesWithIndexes = useMemo(() => {
    return rules ? replaceTagsWithIndexesInRule(rules, stack) : [];
  }, [rules, stack]);

  return rulesWithIndexes;
};
